<template>

    <div class="fuid-errorfromserver" v-if="errors.length">

        <errorPill v-for="(error,index) in errors" :key="index"

            :message="error.message"

        />

    </div>

</template>

<script>

// ----------------------------------------------------------
// To map shit from Vuex
// ----------------------------------------------------------
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
// ----------------------------------------------------------
// Components
// ----------------------------------------------------------
import errorPill from '@/components/errorPill'

export default {

    props: ['id'],

    components: {

        errorPill

    },

    computed: {

        ...mapGetters('Errors', ['getErrorsById']),

        errors() {
            
            return this.getErrorsById( this.id )

        }

    }

}
</script>